<spike-base-page [breadcrumbItems]="breadcrumb" [title]="title()">
    
    <div actions>
        <p-button  label="Posizione" icon="pi pi-plus" (click)="onAdd()"></p-button>
    </div>

    <div>
        <div class="font-bold text-xl mb-1">Posizione aperte</div>
        <div class="spike-table-card mb-4">
        @if (activeInvestments() && activeInvestments().length > 0) {
                <spike-investments-table [items]="activeInvestments()"(onSelect)= "onSelect($event)"/>
        }@else {
            <spike-no-result title="Nessuna operazione trovata" description="Non hai posizioni aperte" icon="pi pi-filter"/>
        }
        </div> 
    </div>

    <div>
        <div class="font-bold text-xl mb-1">Posizioni chiuse</div>
        <div class="spike-table-card">
        @if (closedInvestments() && closedInvestments().length > 0) {
                <spike-investments-table [items]="closedInvestments()" (onSelect)= "onSelect($event)"/>
        }@else {
            <spike-no-result title="Nessuna operazione trovata" description="Non hai posizioni chiuse" icon="pi pi-filter"/>
        }
        </div> 
    </div>

</spike-base-page>


@if(isSidepanelDetailVisible()){
    <spike-isin-side-panel 
        [(isDialogVisible)]="isSidepanelDetailVisible"
        [finIsinId]="selectedInvestment()!.finIsinId!"
        (onSave)="onSave()"
        (onClose)="closeSidePanel()"
        (onDelete)="onDelete()"/>
}


@if(isSidepanelAddVisible()){
    <spike-new-isin-side-panel 
        [(isDialogVisible)]="isSidepanelAddVisible"
        (onSave)="onSave()"
        (onClose)="closeSidePanel()"/>
}
